<template>
    <div>
        大撒大撒大撒
    </div>
</template>
<script>
export default {
    methods: {
        init() {
            console.log(888)
        }
    }
}
</script>